import React, { useRef, useEffect } from 'react'
import { Timeline } from 'antd'
import { injectIntl } from 'react-intl'
import { CheckCircleFilled, ClockCircleOutlined } from '@ant-design/icons'
import milestones from 'assets/documents/roadmap-milestones'
import style from './style.module.scss'

const RoadMap = ({ intl: { locale, formatMessage }}) => {
  const scrollableAreaEl = useRef(null);

  useEffect(() => {
    setTimeout(() => scrollableAreaEl.current && scrollableAreaEl.current.scrollTo(0, scrollableAreaEl.current.scrollHeight), 500)
  }, [])

  return (
    <div className={style.roadmap}>
      <h3>{formatMessage({ id: 'roadmap.title' })}</h3>
      <div ref={scrollableAreaEl} className={style.scrollableArea}>
        <Timeline className={style.timeline}>
          {
            milestones[locale].map(milestone => {
              const attributes = {}

              if (milestone.isFinished) {
                attributes.color = "green"
                attributes.dot = <CheckCircleFilled />
              }

              if (milestone.inProgress) {
                attributes.dot = <ClockCircleOutlined />
              }

              return (
                <Timeline.Item
                  key={milestone.id}
                  {...attributes}
                >
                  <div className={style.date}>{milestone.date}</div>
                  <ul>
                    {milestone.tasks.map(task => <li key={task}>{task}</li>)}
                  </ul>
                </Timeline.Item>
              )
            })
          }
        </Timeline>
      </div>
    </div>
  )
}

export default injectIntl(RoadMap)
